import axios from 'axios'

const API_KEY = process.env.REACT_APP_NASA_API_KEY
const APOD_URL = `https://api.nasa.gov/planetary/apod?api_key=${API_KEY}`

const nasa = axios.create(
  {
    baseURL: APOD_URL
  }
)

export const getApod = async () => {
  const response = await nasa.get()
  return response.data
}